(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  document.getElementById('command').addEventListener('keydown', function(e) {
    if ((e.key === 'Enter' || e.keyCode === 13) && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  });
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.lastSavedValue = '';

      this.addEventListener('change', debounce((event) => {
        const checkoutBtn = document.getElementById("checkout");
        const checkoutBtn_disabled = checkoutBtn.disabled;
        if(checkoutBtn_disabled !== true) {
          checkoutBtn.disabled = true;
        }
        const body = JSON.stringify({ note: event.target.value });
        (async() => {
          const r = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
          if(checkoutBtn_disabled !== true) {
            checkoutBtn.disabled = false;
          }
          this.lastSavedValue = event.target.value;
        })();
      }, 300))
    }

    connectedCallback() {
      const textarea = this.querySelector('textarea');
      const checkoutBtn = document.getElementById("checkout");

      // 注文手続きボタンを押したら備考欄が同期済みか確認
      checkoutBtn.addEventListener('click', async (e) => {
        const currentValue = textarea.value;
        if (currentValue !== this.lastSavedValue) {
          const checkoutBtn_disabled = checkoutBtn.disabled;
          if(checkoutBtn_disabled !== true) {
            checkoutBtn.disabled = true;
          }
          const body = JSON.stringify({ note: currentValue });
          await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
          if(checkoutBtn_disabled !== true) {
            checkoutBtn.disabled = false;
          }
          this.lastSavedValue = currentValue;
        }
      }, true);
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
